import React from 'react';
import { Badge } from './Primitives';
import { recentGenMeta } from '../utils/constants';

/**
 * Badge dello stato GENERALE di generazione di una macrofunzione.
 * Volutamente non conclusivo: la copertura per gli scheletri scelti la dà il
 * piano. Il tooltip lo chiarisce per SUCCESS_AFTER_CHANGE.
 */
export default function GenerationStatusBadge({ status }) {
  const meta = recentGenMeta(status);
  if (!meta) return null;
  return (
    <Badge className={meta.style} title={meta.hint}>
      {meta.label}
    </Badge>
  );
}
